<div appTheme>
    <form (ngSubmit)="onLogin()" #f="ngForm" id="loginForm">
        <div class="modal-box-container main-container" (click)="eatClick($event)">
            <div class="top-columns">
                <div class='col1'>
                    <div class="tall-div">
                        <input (keydown)="onKeypress($event)" class="input-text" type="email" name="email" id="email"
                            [ngModel]="email" placeholder="Email" email required #emailRef="ngModel" />
                        <span class="help-block" *ngIf="!emailRef.valid && emailRef.touched">Please enter a valid email
                            address.</span>
                    </div>
                    <div class="short-div">
                        <input (keydown)="onKeypress($event)" id="pwd" type="password" name="password" [ngModel]="password"
                            placeholder="Password" class="input-text password" required #passwordRef="ngModel" />
                        <span class="help-block" *ngIf="!passwordRef.valid && passwordRef.touched">Please enter your
                            password.</span>
                    </div>
                    <div class="remember-me">
                        <input type="checkbox" id="rememberMe" name="rememberMe" [ngModel]="rememberMe" class="input-checkbox" />
                        <span class="checkbox-text"> Remember Me</span>
                    </div>
                </div>
            </div>
            <div class="error-text" *ngIf="email && password && errorMessageText">
                <span>{{ errorMessageText }}</span><a *ngIf="showResendLink" routerLink="/register/resend"> Resend
                    it?</a>
            </div>
            <div class="bottom text-center">
                <button class="submit-button button-medium" [disabled]="f.invalid" id="signInBtn">
                    Sign In <i class="fa fa-arrow-right" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </form>
</div>
